import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import AOS from 'aos'
import 'aos/dist/aos.css'

AOS.init({
  duration: 1000,
  disable: 'tablet'
  
});

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
